// material-ui
import { useTheme } from '@mui/material/styles';
import APPLOGO from './appmachine-logo.jpeg';
import {Img} from 'react-image'; 
import {Grid,Typography,Divider,Link} from '@mui/material';

/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const Logo = () => {
  const theme = useTheme();

  const handleLogoClick = () => {
    window.location.href = '/';
  };

  return (
    /**
     * if you want to use image instead of svg uncomment following, and comment out <svg> element.
     *
     * <img src={logo} alt="Mantis" width="100" />
     *
     */
    <>
      
      <Grid 
        container 
        direction="column" 
        sx={{
          paddingTop: 3, 
          width: '100%',
          cursor: 'pointer',
          '&:hover': {
            opacity: 0.8,
            transform: 'scale(1.02)'
          },
          transition: 'all 0.2s ease-in-out'
        }} 
        justifyContent="center" 
        alignItems="center"
        onClick={handleLogoClick}
      >
        <Grid item>
          <Img src="/gnr-logo.jpeg" width="200px" height="120px"/>
        </Grid>

         
        <Grid xs={12} item align="center"> 
          <Typography variant="subtitle2" color="secondary" component="span">
            &copy; Powered By&nbsp;
            <a
              href="https://appmachine.in"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: 'inherit', textDecoration: 'underline', fontWeight: 500, cursor: 'pointer' }}
              onClick={e => { e.stopPropagation(); }} // Prevent parent click handlers
            >
              App Machine India
            </a>
          </Typography>
        </Grid>
        <Grid xs={12} item sx={{width:'100%', paddingBottom:'15px'}}> 
          <Divider/>
        </Grid>
        <Grid item>
          <Img src="/gnr-barcode.jpeg" width="200px" height="120px"/>
        </Grid>
         <Grid item>
          <Typography variant="subtitle2" color="secondary" component="span" sx={{paddingTop:2}}>
            Scan to open GNRonline Web App
          </Typography>
         </Grid>
        
      </Grid>
    </>
  );
};

export default Logo;
